import React from 'react';
import { useState, useEffect } from 'react';
import "./link.css"
import { Link, NavLink } from 'react-router-dom';

const CustomLink = (props) => {
   let classNameButton = "forAllLink ";

  
    if(props.size == "small"){
        classNameButton += "smallLink"
    }

    else if(props.size == "big"){
        classNameButton += "bigLink"
    }

    function clickButton(){
        props.clickFunction()
    }
 
    return <>
  <NavLink
  target="_blank"
                to={props.link}>
   <p  className={classNameButton}>{props.children}</p> 
   </NavLink>
    </>;
    };

export default CustomLink;
